/** 完整权限数据
authority:{btn:'search,view,edit,del,add'}
btn按钮权限：search 搜索按钮，view 查看按钮，edit 编辑按钮，del 删除按钮，add 新增按钮
 */
import i18n from '@/i18n/index'
const t = i18n.global.t


export const magHeadermenu = [{
		path: '/mag/asset/index',
		meta: {
			title: t('mag.router.assetindex'),
			icon: 'Coin',
			secondLevel: false
		},
		children: [{
			path: '/mag/asset/index',
			component: () => import('@/views/mag/view/asset/index.vue'),
			meta: {
				title: t('mag.router.assetindex'),
				pPath: '/mag/asset/index',
				elmainClass: 'noTreeBoxMain',
				authority: {
					btn: 'add',
					tableBtn: 'view,edit,del'
				},
				parentTitle: t('mag.router.assetindex'),
				name: 'asset'
			},
		}, {
			path: '/mag/asset/view',
			component: () => import('@/views/mag/view/asset/view/index.vue'),
			meta: {
				elmainClass: 'noTreeBoxMain',
				title: t('mag.router.assetview'),
				pPath: '/mag/asset/index',
				authority: {
					btn: 'add',
					tableBtn: 'edit,del'
				},
				parentTitle: t('mag.router.assetindex'),
				name: 'asset'
			},
		}]
	},
	{
		path: '/mag/device/info',
		meta: {
			title: t('mag.router.deviceinfoTitle'),
			icon: 'Setting',
			secondLevel: true
		},
		children: [{
				path: '/mag/device/info',
				component: () => import('@/views/mag/view/device/info/index.vue'),
				meta: {
					title: t('mag.router.deviceinfo'),
					titleS: t('mag.router.deviceinfoS'),
					icon: 'Tickets',
					pPath: '/mag/device/info',
					leftpPath: '/mag/device/info',
					leftMenuHidden: false,
					elmainClass: 'hasTreeBoxMain',
					authority: {
						btn: 'searchShowForm,search,add,addMore,addMore1,update,export,dellMore,addLnglatMore,energyReplace',
						tableBtn: 'edit,del',
					},
					parentTitle: t('mag.router.deviceinfoTitle'),
					name: 'device'
				},
			},
			{
				path: '/mag/device/groupMag',
				component: () => import('@/views/mag/view/device/groupMag/index.vue'),
				meta: {
					title: t('mag.router.devicegroupMag'),
					titleS: t('mag.router.devicegroupMagS'),
					icon: 'Grid',
					leftMenuHidden: false,
					pPath: '/mag/device/info',
					leftpPath: '/mag/device/groupMag',
					elmainClass: 'noTreeBoxMain',
					authority: {
						btn: 'add',
						tableBtn: 'edit,view,del'
					},
					parentTitle: t('mag.router.deviceinfoTitle'),
					name: 'device'
				},
			},
			{
				path: '/mag/device/groupMag/view',
				component: () => import('@/views/mag/view/device/groupMag/view/index.vue'),
				meta: {
					title: t('mag.router.devicegroupMagview'),
					icon: 'denggan',
					leftMenuHidden: false,
					leftMenuItemHidden: true,
					pPath: '/mag/device/info',
					leftpPath: '/mag/device/groupMag',
					elmainClass: 'noTreeBoxMain',
					authority: {
						btn: 'searchShowForm,searchHideForm,editDevicesGroup',
						tableBtn: 'editDevicesGroup'
					},
					parentTitle: t('mag.router.deviceinfoTitle'),
					name: 'device'
				},
			},
			{
				path: '/mag/device/setting',
				component: () => import('@/views/mag/view/device/setting/index.vue'),
				meta: {
					title: t('mag.router.Setting'),
					titleS: t('mag.router.SettingS'),
					icon: 'Setting',
					leftMenuHidden: false,

					pPath: '/mag/device/info',
					leftpPath: '/mag/device/setting',
					elmainClass: 'noTreeBoxMain',
					authority: {
						btn: 'add,add1',
						tableBtn: 'del2,edit'
					},
					parentTitle: t('mag.router.deviceinfoTitle'),
					name: 'device'
				},
			},
			{
				path: '/mag/device/energy',
				component: () => import('@/views/mag/view/device/energy/index.vue'),
				meta: {
					title: t('mag.router.energy'),
					titleS: t('mag.router.energyS'),
					icon: 'Odometer',
					leftMenuHidden: false,
					pPath: '/mag/device/info',
					leftpPath: '/mag/device/energy',
					elmainClass: 'hasTreeBoxMain',
					authority: {
						btn: 'searchShowForm,export,add',
					},
					parentTitle: t('mag.router.deviceinfoTitle'),
					name: 'device'
				},
			},
			{
				path: '/mag/device/lightRate',
				component: () => import('@/views/mag/view/device/lightRate/index.vue'),
				meta: {
					title: t('mag.router.lightRate'),
					titleS: t('mag.router.lightRateS'),
					icon: 'Odometer',
					leftMenuHidden: false,
					pPath: '/mag/device/info',
					leftpPath: '/mag/device/lightRate',
					elmainClass: 'noTreeBoxMain',
					authority: {
						btn: 'searchShowForm,export,add',
					},
					parentTitle: t('mag.router.deviceinfoTitle'),
					name: 'device'
				},
			},
			{
				path: '/mag/device/activity',
				component: () => import('@/views/mag/view/device/activity/index.vue'),
				meta: {
					title: t('mag.router.activity'),
					titleS: t('mag.router.activityS'),
					icon: 'Odometer',
					leftMenuHidden: false,
					pPath: '/mag/device/info',
					leftpPath: '/mag/device/activity',
					elmainClass: 'hasTreeBoxMain',
					authority: {
						btn: 'searchShowForm,exportExcel,exportWord,dellMore,searchHideForm',
						tableBtn: 'del,view'
					},
					parentTitle: t('mag.router.deviceinfoTitle'),
					name: 'device'
				},
			},
			{
				path: '/mag/device/sim',
				component: () => import('@/views/mag/view/device/sim/index.vue'),
				meta: {
					title: t('mag.router.sim'),
					titleS: t('mag.router.simS'),
					icon: 'Cellphone',
					leftMenuHidden: false,
					pPath: '/mag/device/info',
					leftpPath: '/mag/device/sim',
					elmainClass: 'noTreeBoxMain',
					authority: {
						btn: 'searchShowForm',
					},
					parentTitle: t('mag.router.deviceinfoTitle'),
				},
			},
			{
				path: '/mag/device/scene',
				// component: { render: h => h('router-view') }, 
				component: () => import('@/views/mag/view/device/scene/index.vue'),
				meta: {
					title: t('mag.router.scene'),
					titleS: t('mag.router.sceneS'),
					icon: 'film',
					parentTitle: t('mag.router.deviceinfoTitle'),
					authority: {
						btn: 'add,dellMore',
						tableBtn: 'del,edit,enabledisable,logout'
					},
					elmainClass: 'noTreeBoxMain',
					name: 'device'
				},
				children: [{
						path: '/mag/device/scene/configuration', // 改为相对路径
						component: () => import('@/views/mag/view/device/scene/configuration/index.vue'),
						meta: {
							title: t('mag.router.configuration'),
						leftpPath: '/mag/device/scene/configuration', // 指向自身
						pPath: '/mag/device/info',
						leftMenuHidden: false,
						elmainClass: 'noTreeBoxMain',
							authority: {
								btn: 'add,dellMore',
								tableBtn: 'del,edit,enabledisable,logout'
							},
							name: 'device'
						}
					},
					{
						path: '/mag/device/scene/mode', // 改为相对路径
						component: () => import('@/views/mag/view/device/scene/mode/index.vue'),
						meta: {
							title: t('mag.router.mode'),
						leftpPath: '/mag/device/scene/mode', // 指向自身
						pPath: '/mag/device/info',
						leftMenuHidden: false,
						elmainClass: 'noTreeBoxMain',
							authority: {
								btn: 'add,dellMore',
								tableBtn: 'del,edit,enabledisable'
							},
							name: 'device'
						}
					},
				]
			},
		]
	},
	{
		path: '/mag/deviceController/index',
		meta: {
			title: t('mag.router.deviceController'),
			icon: 'Document',
			secondLevel: false
		},
		children: [{
				path: '/mag/deviceController/index',
				component: () => import('@/views/mag/view/deviceController/index.vue'),
				meta: {
					elmainClass: 'hasTreeBoxMain',
					title: t('mag.router.deviceController'),
					pPath: '/mag/deviceController/index',
					authority: {
						btn: 'searchShowForm,search,add,lightOption,rd,syncTime,reb,as,SIM,batchReadIPP,batchIPP,setGP,setLdcs,skhl,setHlgg,setJwdpyz,setGJZQ,setHgqzsb,setKglsc,setSbsjzq,setJzqczkg,syncRgj,syncJwd,syncRhlgg,syncHlNb,setHlNb,setHlRm,setHLZR,getHLZR,getSxjlxs,setSxjlxs,rjl,syncDDZR,setDDZR,setBmd,syncBmd,syncHLZR,syncDDQKGGTG,setLxzq,setJzqckg,tgByGroup,setDDQKRBMS,setDDQKGGTG,setWSGD,reset,setGpnum,setTM,readTm,setLxkg,syncJr,syncZr,syncGpnum,syncDDQKJR,setDDQKJR,setWlid,syncWlid,fotaCenterLight,setTgbc,setTgrbms,setTgnb,setTgzr,setTggg,jzqczkg,syncTgnb,syncTggg,syncTgzr,async8DV,async3SI,async3SO,clearCache,dimLightOption,setTglj,save,setTgmrv,setVjl,setIjl,setPjl,readE,readE1,setRm,setDdldggld,readLc,setLc,setLcov,wlsd,setZjid,setCjid,excelDownload,hkSetJwd,HKSetConfigId,hksetChannel,setSxjlxs7,setG,readG,setLkg,readLkg,setRC,readRC,setAic,readAic,set433,read433,readV,setRkg,readRkg,setRTC,readRTC,setRtp,readRtp,setTo,readTo,setHlfdtg,setWarnsafe,setGPR,syncGPR',
						tableBtn: 'monitor,location,hksetChannel'
					},
					parentTitle: t('mag.router.deviceController'),
					name: 'control_device'
				},
			},
			{
				path: '/mag/deviceController/view',

				component: () => import('@/views/mag/view/deviceController/view/index.vue'),
				meta: {
					title: t('mag.router.deviceRecord'),
					pPath: '/mag/deviceController/index',
					authority: {
						btn: 'searchShowForm',
					},
					elmainClass: 'noTreeBoxMain',
					parentTitle: t('mag.router.deviceController'),
					// name:'control_device'
				},
			}
		]
	},
	{
		path: '/mag/work/transfer',
		meta: {
			title: t('mag.router.alarmindex'),
			icon: 'Setting',
			secondLevel: true
		},
		children: [{
				path: '/mag/work/transfer',
				component: () => import('@/views/mag/view/work/transfer/index.vue'),
				meta: {
					title: t('mag.router.worktransfer'),
					titleS: t('mag.router.worktransferS'),
					icon: 'Tickets',
					pPath: '/mag/work/transfer',
					leftpPath: '/mag/work/transfer',
					leftMenuHidden: false,
					elmainClass: 'noTreeBoxMain',
					authority: {
						btn: 'searchShowForm,add,search,ignore',
						tableBtn: 'del,view',
					},
					parentTitle: t('mag.router.alarmindex'),
					name: 'create_work_order'
				},
			}, {
				path: '/mag/work/info',
				component: () => import('@/views/mag/view/work/info/index.vue'),
				meta: {
					title: t('mag.router.workinfo'),
					titleS: t('mag.router.workinfoS'),
					icon: 'Tickets',
					pPath: '/mag/work/transfer',
					leftpPath: '/mag/work/info',
					leftMenuHidden: false,
					elmainClass: 'noTreeBoxMain',
					authority: {
						btn: 'searchShowForm,add,search',
						tableBtn: 'del,view',
					},
					parentTitle: t('mag.router.alarmindex'),
					name: 'create_work_order'
				},
			},
			{
				path: '/mag/work/view',
				component: () => import('@/views/mag/view/work/view/index.vue'),
				meta: {
					title: t('mag.router.alarmindex'),
					pPath: '/mag/work/view',
					leftMenuItemHidden: true,
					parentTitle: t('mag.router.alarmindex'),
					elmainClass: 'noTreeBoxMain',
					authority: {
						btn: '',
					},
				},
			},
			{
				path: '/mag/work/handle',
				component: () => import('@/views/mag/view/work/handle/index.vue'),
				meta: {
					title: t('mag.router.workHandle'),
					titleS: t('mag.router.workHandleS'),
					icon: 'Grid',
					leftMenuHidden: false,
					pPath: '/mag/work/transfer',
					leftpPath: '/mag/work/handle',
					elmainClass: 'noTreeBoxMain',
					authority: {
						btn: '',
						tableBtn: 'view'
					},
					parentTitle: t('mag.router.alarmindex'),
					name: "receive_work_order"
				},
			},
			{
				path: '/mag/work/historyData',
				component: () => import('@/views/mag/view/work/historyData/index.vue'),
				meta: {
					title: t('mag.router.workHistory'),
					titleS: t('mag.router.workHistoryS'),
					icon: 'Odometer',
					leftMenuHidden: false,
					pPath: '/mag/work/transfer',
					leftpPath: '/mag/work/historyData',
					elmainClass: 'noTreeBoxMain',
					authority: {
						btn: '',
						tableBtn: 'view'
					},
					parentTitle: t('mag.router.alarmindex'),
				},
			},
		]
	},
	{
		path: '/mag/ruleStrategy/info',
		meta: {
			title: t('mag.router.ruleStrategyindex'),
			icon: 'SetUp',
			secondLevel: true
		},
		children: [{
				path: '/mag/ruleStrategy/info',
				component: () => import('@/views/mag/view/ruleStrategy/info/index.vue'),
				meta: {
					title: t('mag.router.ruleStrategyInfo'),
					titleS: t('mag.router.ruleStrategyInfoS'),
					icon: 'Tickets',
					pPath: '/mag/ruleStrategy/info',
					leftpPath: '/mag/ruleStrategy/info',
					leftMenuHidden: false,
					elmainClass: 'noTreeBoxMain',
					authority: {
						btn: 'add1,add2,add',
						tableBtn: 'del,clone,on,off,cancel,editNew'
					},
					parentTitle: t('mag.router.ruleStrategyInfo'),
					name: 'strategy_rule'
				},
				// children: [{
				// 	path: '/mag/ruleStrategy/info/view', // 改为相对路径
				// 	component: () => import('@/views/mag/view/ruleStrategy/info/view/index.vue'),
				// 	meta: {
				// 		title: '',
				// 		pPath: '/mag/ruleStrategy/info/view',
				// 		leftMenuHidden: true,
				// 		authority: {
				// 			btn: 'searchShowForm,refresh',
				// 			tableBtn: 'retry,message'
				// 		},
				// 	}
				// }]
			},
			{
				path: '/mag/ruleStrategy/group',
				component: () => import('@/views/mag/view/ruleStrategy/group/index.vue'),
				meta: {
					title: t('mag.router.ruleStrategyGroup'),
					titleS: t('mag.router.ruleStrategyGroupS'),
					icon: 'Tickets',
					pPath: '/mag/ruleStrategy/info',
					leftpPath: '/mag/ruleStrategy/group',
					leftMenuHidden: false,
					elmainClass: 'noTreeBoxMain',
					authority: {
						btn: 'addGroup',
						tableBtn: 'del,cloneNew,editNew'
					},
					parentTitle: t('mag.router.ruleStrategyInfo'),
					name: 'strategy_rule'
				},
			},
			{
				path: '/mag/ruleStrategy/info/view', // 改为相对路径
				component: () => import('@/views/mag/view/ruleStrategy/info/view/index.vue'),
				meta: {
					title: t('mag.router.ruleStrategyInfoV'),
					pPath: '/mag/ruleStrategy/info/view',
					leftMenuHidden: true,
					leftMenuItemHidden: true,
					authority: {
						btn: 'searchShowForm,refresh',
						tableBtn: 'retry,message'
					},
					elmainClass: 'noTreeBoxMain',
					parentTitle: t('mag.router.ruleStrategyInfo'),
				}
			},
			{
				path: '/mag/ruleStrategy/group/view', // 改为相对路径
				component: () => import('@/views/mag/view/ruleStrategy/group/view/index.vue'),
				meta: {
					title: t('mag.router.ruleStrategyGroupV'),
					pPath: '/mag/ruleStrategy/group/view',
					leftMenuHidden: true,
					leftMenuItemHidden: true,
					authority: {
						btn: 'searchShowForm',
						tableBtn: ''
					},
					elmainClass: 'noTreeBoxMain',
					parentTitle: t('mag.router.ruleStrategyInfo'),
				}
			},
		]
	},
	{
		path: '/mag/log/index',
		meta: {
			title: t('mag.router.logindex'),
			icon: 'Document',
		},
		children: [{
			path: '/mag/log/index',
			component: () => import('@/views/mag/view/log/index.vue'),
			meta: {
				elmainClass: 'noTreeBoxMain',
				title: t('mag.router.logindex'),
				titleS: t('mag.router.logindexS'),
				pPath: '/mag/log/index',
				authority: {
					btn: 'searchShowForm,export,clear,del',
				},
				parentTitle: t('mag.router.logindex'),
				name: 'log'
			},
		}]
	},
	{
		path: '/mag/task/task',
		meta: {
			title: t('mag.router.task'),
			icon: 'SetUp',
			secondLevel: true
		},
		children: [{
				path: '/mag/task/task',
				component: () => import('@/views/mag/view/task/task/index.vue'),
				meta: {
					title: t('mag.router.task'),
					titleS: t('mag.router.taskS'),
					icon: 'Tickets',
					pPath: '/mag/task/task',
					leftpPath: '/mag/task/task',
					leftMenuHidden: false,
					elmainClass: 'noTreeBoxMain',
					authority: {
						btn: 'add',
						tableBtn: 'del,on,off,runOnce,edit,view'
					},
					parentTitle: t('mag.router.task'),
					name: 'task'
				},
			},
			{
				path: '/mag/task/record',
				component: () => import('@/views/mag/view/task/record/index.vue'),
				meta: {
					title: t('mag.router.taskRecord'),
					titleS: t('mag.router.taskRecordS'),
					icon: 'Tickets',
					pPath: '/mag/task/info',
					leftpPath: '/mag/task/record',
					leftMenuHidden: false,
					elmainClass: 'noTreeBoxMain',
					authority: {
						btn: 'dellMore,exportExcel',
						tableBtn: 'del,view'
					},
					parentTitle: t('mag.router.taskRecord'),
					name: 'task'
				},
			},
			{
				path: '/mag/task/record/view',
				component: () => import('@/views/mag/view/task/record/view/index.vue'),
				meta: {
					title: t('mag.router.deviceRecord'),
					pPath: '/mag/task/record/view',
					authority: {
					},
					leftMenuHidden: true,
					leftMenuItemHidden: true,
					elmainClass: 'noTreeBoxMain',
					parentTitle: t('mag.router.deviceController'),
					// name:'control_device'
				},
			},{
				path: '/mag/task/task/view',
				component: () => import('@/views/mag/view/task/task/view/index.vue'),
				meta: {
					title: t('mag.router.deviceRecord'),
					pPath: '/mag/task/task/view',
					authority: {
					},
					leftMenuHidden: true,
					leftMenuItemHidden: true,
					elmainClass: 'noTreeBoxMain',
					parentTitle: t('mag.router.deviceController'),
					// name:'control_device'
				},
			},
		]
	},
	{
		path: '/mag/user/user',
		meta: {
			title: t('mag.router.user'),
			icon: 'User',
			authorityUser: 'admin',
			secondLevel: true
		},
		children: [{
				path: '/mag/user/user',
				component: () => import('@/views/mag/view/user/user/index.vue'),
				meta: {
					authorityUser: 'admin',
					title: t('mag.router.user'),
					titleS: t('mag.router.userS'),
					icon: 'Tickets',
					pPath: '/mag/user/user',
					leftpPath: '/mag/user/user',
					leftMenuHidden: false,
					elmainClass: 'noTreeBoxMain',
					authority: {
						btn: 'search,add,del',
						tableBtn: 'edit,batchDel,enabledisable,logout,authority,pswchange,alarm'
					},
					parentTitle: t('mag.router.user'),
				},
			},
			// {
			// 	path: '/mag/user/media',
			// 	component: () => import('@/views/mag/view/user/media/index.vue'),
			// 	meta: {
			// 		title: t('mag.router.media'),
			// 		icon: 'CameraFilled',
			// 		pPath: '/mag/user/user',
			// 		leftpPath: '/mag/user/media',
			// 		leftMenuHidden: false,
			// 		elmainClass: 'noTreeBoxMain',
			// 		authority: {
			// 			btn: 'add,dellMore',
			// 			tableBtn: 'edit,del'
			// 		}
			// 	},
			// },
			{
				path: '/mag/user/third',
				component: () => import('@/views/mag/view/user/third/index.vue'),
				meta: {
					title: t('mag.router.third'),
					titleS: t('mag.router.thirdS'),
					icon: 'Setting',
					pPath: '/mag/user/user',
					leftpPath: '/mag/user/third',
					leftMenuHidden: false,
					elmainClass: 'noTreeBoxMain',
					authority: {
						btn: 'add,dellMore',
						tableBtn: 'edit,del'
					},
					parentTitle: t('mag.router.user'),
				},
			},
		]
		// children: [{
		// 	path: '/mag/user/index',

		// 	component: () => import('@/views/mag/view/user/index.vue'),
		// 	meta: {

		// 		title: t('mag.router.user'),
		// 		pPath: '/mag/user/index',
		// 		authorityUser: 'admin',
		// 		authority: {
		// 			btn: 'search,add,del,pswchange',
		// 			tableBtn: 'edit,batchDel,enabledisable,logout,authority'
		// 		}
		// 	},
		// }]
	},
	{
		path: '/mag/deviceSearch/index',
		meta: {
			title: t('mag.router.deviceSearch'),
			icon: 'Search',
			authorityUser: 'admin',
			authorityShow: 'true',
		},
		children: [{
			path: '/mag/deviceSearch/index',

			component: () => import('@/views/mag/view/deviceSearch/index.vue'),
			meta: {

				title: t('mag.router.deviceSearch'),
				pPath: '/mag/deviceSearch/index',
				authorityUser: 'admin',
				authorityShow: 'true',
				authority: {
					btn: 'add,del,pswchange',
					tableBtn: 'edit,batchDel,enabledisable,logout'
				},
				elmainClass: 'noTreeBoxMain',
				parentTitle: t('mag.router.deviceSearch'),
			},
		}]
	},
	{
		path: '/mag/deviceTotal/index',
		meta: {
			title: t('mag.router.deviceTotal'),
			icon: 'Postcard',
			authorityUser: 'admin',
			authorityShow: 'true',
		},
		children: [{
			path: '/mag/deviceTotal/index',
			component: () => import('@/views/mag/view/deviceTotal/index.vue'),
			meta: {
				title: t('mag.router.deviceTotal'),
				pPath: '/mag/deviceTotal/index',
				authorityUser: 'admin',
				authorityShow: 'true',
				elmainClass: 'noTreeBoxMain',
				authority: {
					btn: 'searchShowForm',
				},
				parentTitle: t('mag.router.deviceTotal'),
			},
		}]
	},
	// {
	//   path: '/mag/communication/index',
	//   meta: {
	//     title: t('mag.router.communication'),
	//     icon: 'Link',
	//     authorityUser: 'admin'
	//     authorityShow:'true'
	//   },
	//   children: [{
	//     path: '/mag/communication/index',

	//     component: () => import('@/views/mag/view/communication/index.vue'),
	//     meta: {

	//       title: t('mag.router.communication'),
	//       pPath: '/mag/communication/index',
	//       authorityUser: 'admin',
	//       authorityShow:'true',
	//       authority: {
	//         btn: 'search,pswchange',
	//         tableBtn: 'edit,batchDel,enabledisable,logout'
	//       }
	//     },
	//   }]
	// },
]